import React from 'react'
import Logo from './svg/Logo'
import { Link, Box } from './styled'

const COLORS = [
  'inherit',
  '#2AA3EF',
  '#FDAD2A',
  '#8D65F2',
  '#ED3A5B',
  '#F98FA6'
]

const css = {
  userSelect: 'none'
}

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      i: 0
    }
    this.handleRightClick = this.handleRightClick.bind(this)
  }

  handleRightClick(e) {
    e.preventDefault()
    this.setState(({ i }) => ({ i: (i + 1) % COLORS.length }))
  }

  render() {
    const { ...rest } = this.props
    return (
      <Box css={css} {...rest} onContextMenu={this.handleRightClick} mt="-4px">
        <Link to="/">
          <Logo color={COLORS[this.state.i]} />
        </Link>
      </Box>
    )
  }
}

export default Header
